import React from "react";
import { Box, Typography } from "@mui/material";
import ChartsView from "../components/ChartsView";

const StatisticsPage: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Estatísticas
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Visualize estatísticas e gráficos das suas faturas.
        </Typography>
      </Box>
      <ChartsView />
    </Box>
  );
};

export default StatisticsPage;
